import Api from '../config/api';
import { CCPhone, ICCPhone, ICCPhoneResponse } from '../models/Phones/CCPhone';
import { IError } from '../models/IError';

export interface IAxiosCCPhones {
  data: ICCPhoneResponse;
}

export interface IAxiosCCPhone {
  data: ICCPhone;
}

export class PhonesActions {
  static getPhones(filterString: string): Promise<IAxiosCCPhones> {
    return Api.get('/phones?' + filterString);
  }

  static getPhone(id: number): Promise<CCPhone> {
    return Api.get('/phones/' + id)
      .then((res: IAxiosCCPhone) => new CCPhone(res.data));
  }

  static createPhone(phone: string): Promise<CCPhone | IError> {
    return Api.post('/phones', { phone })
      .then((res: IAxiosCCPhone) => new CCPhone(res.data))
      .catch((res: any): IError => res.response.data);
  }

  static updatePhone(id: number, data: Partial<ICCPhone>): Promise<CCPhone | IError> {
    return Api.put('/phones/' + id, data)
      .then((res: IAxiosCCPhone) => new CCPhone(res.data))
      .catch((res: any): IError => res.response.data);
  }

  static deletePhone(id: number): Promise<boolean | IError> {
    return Api.delete('/phones/' + id)
      .then(() => true)
      .catch((res: any): IError => res.response.data);
  }
}
